import React, { Component } from "react";
import { connect } from "react-redux";
import * as fs from "expo-file-system";
import * as ExpoPermissions from "expo-permissions";
import DraggableFlatList from "react-native-draggable-flatlist";
import {
  View,
  StyleSheet,
  Image,
  TouchableHighlight,
  ScrollView,
  KeyboardAvoidingView,
  TouchableWithoutFeedback,
  Platform,
} from "react-native";
import Switch from "../components/ToggleSwitch";
import Text from "../components_v2/TextFont";

import * as Actions from "../actions/DeviceActions";
import { translate } from "../locales/translate";
import Loading from "../components/Loading";

import Theme from "../argon-ui/Theme";
import ArButton from "../argon-ui/Button";

import {
  faCheck,
  faCheckCircle,
  faCheckSquare,
  faEdit,
  faHourglass,
  faMinusCircle,
  faPauseCircle,
  faPlayCircle,
  faPlusCircle,
  faSquare,
  faTrashAlt,
  faUndo,
  faUpload,
  FONT_FAMILIES,
} from "../../assets/consts/faCharCodes";
import { IconButton, SimpleIcon } from "../components_v2/Buttons";
import SimpleDraggableItem from "../components_v2/SimpleDraggableItem";
import InputBase from "../nativeBase-ui/InputBase";
import { HStack } from "native-base";
import InputSearch from "../components_v2/InputSearch";
import AlertDialogBase from "../nativeBase-ui/AlertDialog";
import { messageToast } from "../actions/AppActions";
let MusicFiles = {};
let TrackPlayer = {};
if (Platform.OS != "web") {
  MusicFiles = require("react-native-get-music-files").default;
  TrackPlayer = require("react-native-track-player").default;
}
const axios = require("axios").default;
const RENDER_MODE = {
  FORM: "form",
  LIST: "list",
};
class MediaPlayListFormScreen extends Component {
  constructor(props) {
    super(props);
    let { id, uId, smartSpeakerDeviceId, smartSpeakerDeviceUId } =
      this.props.navigation.state.params;

    this.state = {
      id: id || 0,
      uId: uId || null,
      smartSpeakerDeviceId,
      smartSpeakerDeviceUId,
      renderMode:
        !id && Platform.OS != "web" ? RENDER_MODE.LIST : RENDER_MODE.FORM,
      title: translate("multiMedia.newPlayListTitle"),
      isPublic: true,
      tracks: [],

      tracksLoaded: Platform.OS == "web", // set as true if is web, otherwise wait till tracks loaded by native module

      // all musics exists in client device storage
      localTracks: [],
      // musics selected to upload
      tempSelectedTracks: [],
      // current playing music from local storage
      tempPlayingPath: "",
      searchFilter: "",

      isLoading: id > 0,
      isSaving: false,

      validation_title_hasError: false,
      validationErrors: [],

      showDeleteConfirm: false,
      random: 0,
    };

    this.sound = {}; // new Sound();
    this.FileBrowserRef = undefined;
  }
  static navigationOptions = ({ screenProps: { translate } }) => ({
    headerTitle: translate("navigation.MediaPlayListForm"),
  });
  async componentDidMount() {
    this.setState({
      buildingId: this.props.AppReducer?.currentBuilding.buildingId,
      accessToken: this.props.AppReducer?.currentServer.accessToken,
    });
    await this.getMusicList();
    if (Platform.OS != "web") await TrackPlayer.setupPlayer();
    if (this.state.id > 0 || this.state.uId) {
      var playList = this.props.DeviceReducer.playLists.find(
        (p) => p.id == this.state.id || p.uId == this.state.uId
      );
      if (playList) {
        this.setState({
          title: playList.title,
          isPublic: playList.isPublic,
          tracks: playList.tracks,
          isLoading: false,
        });
      }
    }
  }

  async componentWillUnmount() {
    if (Platform.OS != "web") await TrackPlayer.reset();
  }

  async getMusicList() {
    var hasPerm = (
      await ExpoPermissions.getAsync(ExpoPermissions.MEDIA_LIBRARY)
    ).granted;
    if (!hasPerm) {
      hasPerm = (await ExpoPermissions.askAsync(ExpoPermissions.MEDIA_LIBRARY))
        .granted;
    }
    if (hasPerm && Platform.OS != "web") {
      // console.log("start get music files");
      var tracks = await MusicFiles.getAll({
        id: true,
        cover: true,
        author: true,
        duration: true,
      });
      // console.log(
      //   "tracks in MediaPlayListFormScreen.getMusicList()",
      //   tracks,
      //   "tracks in MediaPlayListFormScreen.getMusicList()"
      // );
      this.setState({ localTracks: [...tracks], tracksLoaded: true });
    } else {
      console.log(
        "storage permission denied in MediaPlayListFormScreen.getMusicList()"
      );
    }
  }

  addTrackToTempList(track) {
    var tempSelectedTracks = [...this.state.tempSelectedTracks];

    var trackModel = new MusicTrackSelection();
    trackModel.isTemp = true;
    trackModel.order = this.state.tracks.length + tempSelectedTracks.length + 1;
    trackModel.path = track.path;
    trackModel.title = track.title || "";
    trackModel.duration = track.duration || 0;
    if (Platform.OS == "web") {
      trackModel.title = track.name;
      trackModel.blob = track;
      trackModel.path = track.name; // to distinguish files with `undefined` path
    }

    tempSelectedTracks.push(trackModel);
    this.setState({ tempSelectedTracks });
  }

  removeTrackFromTempList(trackPath) {
    var tempSelectedTracks = [...this.state.tempSelectedTracks];
    var startReOrder = false;
    for (var i in this.state.tempSelectedTracks) {
      if (startReOrder && i > 0) {
        tempSelectedTracks[i - 1].order--;
      }
      if (this.state.tempSelectedTracks[i].path == trackPath) {
        tempSelectedTracks.splice(i, 1);
        startReOrder = true;
      }
    }
    this.setState({ tempSelectedTracks });
  }

  toggleTrackRemoved(id) {
    // console.log("toggle remove id", id);
    let { tracks } = this.state;
    for (const i in tracks) {
      const track = tracks[i];
      if (track.id == id) {
        tracks[i].isRemoved = !track.isRemoved;
        this.setState({ tracks: [...tracks] });
        return;
      }
    }
  }

  markTrackAsRemoved(trackId) {
    var tracks = [...this.state.tracks];
    for (let i = 0; i < tracks.length; i++) {
      const track = tracks[i];
      if (track.id == trackId) {
        track.isRemoved = true;
        this.setState({ tracks });
        break;
      }
    }
  }

  manuallyChangeTracksSort = (from, to) => {
    if (from == to) return;

    let { tracks, tempSelectedTracks } = this.state;
    if (to < 0 || to >= tracks.length + tempSelectedTracks.length) return;

    var allItems = tracks.concat(tempSelectedTracks);
    if (from < to) {
      // change order of all items in middle section
      allItems[from].order = allItems[to].order;
      for (let i = from + 1; i <= to; i++) {
        allItems[i].order--;
      }
    } else {
      allItems[from].order = allItems[to].order;
      for (let i = to; i <= from - 1; i++) {
        allItems[i].order++;
      }
    }

    allItems.sort((a, b) => (a.order || 0) - (b.order || 0));

    var _tracks = allItems.filter((t) => t.id && t.id.length > 0);
    var _tempSelectedTracks = allItems.filter((t) => !t.id);

    this.setState({
      tracks: [..._tracks],
      tempSelectedTracks: [..._tempSelectedTracks],
    });
  };

  goBack() {
    this.props.navigation.goBack();
  }

  showDeletePlaylistConfirm = () => {
    this.setState({
      showDeleteConfirm: true,
    });
  };

  hideDeletePlaylistConfirm = () => {
    this.setState({
      showDeleteConfirm: false,
    });
  };

  async save() {
    // === validation ===
    if (!this.state.title) {
      const message = {
        title: translate("smartSpeaker.errors.isRequiredTitlePalyList"),
        variant: "top-accent",
        status: "error",
        duration: 2500,
      };
      this.props.messageToast(message);
      return;
    }

    var tempSelectedTracksToStart = [...this.state.tempSelectedTracks];
    for (const i in tempSelectedTracksToStart) {
      const track = tempSelectedTracksToStart[i];
      track.uploadStatus = MusicTrackSelection.UPLOAD_STATUS_WAITING;
    }

    this.setState({
      isSaving: true,
      tempSelectedTracks: tempSelectedTracksToStart,
    });
    let {
      id,
      uId,
      smartSpeakerDeviceId,
      smartSpeakerDeviceUId,
      isPublic,
      title,
      tracks,
      tempSelectedTracks,
      buildingId,
      accessToken,
    } = this.state;
    let serverUrl = this.props.AppReducer.serverUrl;
    if (!serverUrl.endsWith("/")) serverUrl += "/";
    var playListEntity = {
      id,
      uId,
      smartSpeakerDeviceId,
      smartSpeakerDeviceUId,
      title,
      isPublic,
    };

    var headersJson = {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: `Bearer ${accessToken}`,
    };

    var headersMultiPart = {
      Accept: "application/json",
      "Content-Type": "multipart/form-data",
      Authorization: `Bearer ${accessToken}`,
    };

    try {
      if (!serverUrl.endsWith("/")) serverUrl += "/";
      if (id == 0 || uId == "") {
        var api = `${serverUrl}MultiMedia/CreatePlayList`;

        var createResult = await axios.post(api, playListEntity, {
          headers: headersJson,
        });
        if (
          createResult.data &&
          ((createResult.data.uId && createResult.data.uId) ||
            createResult.data.id)
        )
          id = createResult.data?.id;
        uId = createResult.data?.uId;
        this.props.addPlaylistLocally(createResult.data);
        // console.log("new playList created with id", id);
      } else {
        var api = `${serverUrl}MultiMedia/EditPlayList`;

        var createResult = await axios.post(api, playListEntity, {
          headers: headersJson,
        });

        if (
          createResult.data &&
          ((createResult.data.uId && createResult.data.uId) ||
            createResult.data.id)
        )
          id = createResult.data.id;
        uId = createResult.data.uId;

        this.props.updatePlaylistLocally(createResult.data);
      }
    } catch (error) {
      console.log("error on save playlist entity", error);
    }

    if (id > 0) {
      if (tracks.some((t) => t.isRemoved)) {
        var removeTrackApi = `${serverUrl}MultiMedia/RemoveTrackFromPlayList`;
        for (const i in tracks) {
          const track = tracks[i];
          if (track.isRemoved) {
            var singleRemoveApi = `${removeTrackApi}?trackId=${track.id}&playListId=${id}&buildingId=${this.state.buildingId}`;
            try {
              await axios.post(singleRemoveApi, null, {
                headers: headersJson,
              });
              this.props.removeTrackLocally(track.id, id);
            } catch (error) {
              console.log("error on remove track from playlist", error);
            }
          }
        }
      }

      var uploadApi = `${serverUrl}MultiMedia/AddTrack`;
      var speaker = this.props.DeviceReducer.list.find(
        (d) =>
          (this.state.smartSpeakerDeviceUId &&
            d.deviceUId == this.state.smartSpeakerDeviceUId) ||
          d.deviceId == this.state.smartSpeakerDeviceId
      );
      for (const i in tempSelectedTracks) {
        try {
          const track = tempSelectedTracks[i];
          let { order, path, title, duration } = track;
          console.log("uploading tracks for playlist", id, title, buildingId);
          var ext = (path.match(/\.[\d\w]+$/) || [""])[0];
          var name = `${title}${ext}`;
          //console.log("track data", track);
          var payload = new FormData();
          payload.append("playListId", id);
          payload.append("playListUId", uId);
          payload.append("order", order);
          payload.append("duration", duration);
          payload.append("isPublic", isPublic);
          payload.append("buildingId", buildingId);
          payload.append("storageServerId", speaker?.storageServerId);
          payload.append("track", {
            uri: Platform.OS === "android" ? `${path}` : path,
            name: name,
            type: "audio/mp3",
          });

          for (const j in tempSelectedTracksToStart) {
            const sttTrack = tempSelectedTracksToStart[j];
            if (sttTrack.path == path) {
              sttTrack.uploadStatus =
                MusicTrackSelection.UPLOAD_STATUS_UPLOADING;
              this.setState({
                tempSelectedTracks: [...tempSelectedTracksToStart],
              });
              break;
            }
          }
          var filePath = path;
          if (Platform.OS === "android") {
            filePath = `file://${filePath}`;
          }

          //var info = await fs.getInfoAsync(path);

          //console.log("uploading file, using file system", path , info);
          var uploadResponse = await fs.uploadAsync(uploadApi, filePath, {
            fieldName: "track", // input name in api side
            headers: headersMultiPart,
            httpMethod: "POST",
            mimeType: "audio/mp3",
            uploadType: fs.FileSystemUploadType.MULTIPART,
            sessionType: fs.FileSystemSessionType.BACKGROUND,
            parameters: {
              playListId: `${id}`,
              playListUId: `${uId}`,
              order: `${order}`,
              duration: `${duration}`,
              isPublic: `${isPublic}`,
              buildingId: `${buildingId}`,
            },
          });
          // console.log("t upload using fs", t.body);

          // console.log("payload to upload", payload);
          // var uploadResponse = await axios.post(
          //   uploadApi,
          //   payload,
          //   uploadOptions
          // );
          if (uploadResponse.status === 200) {
            if (uploadResponse.body) {
              var uploadResult;
              try {
                uploadResult = JSON.parse(uploadResponse.body);
              } catch (error) {
                console.log(
                  "error on parse music upload result",
                  error,
                  uploadResponse
                );
              }
              if (uploadResult) {
                this.props.addTrackLocally(uploadResult, id);
                for (const j in tempSelectedTracksToStart) {
                  const sttTrack = tempSelectedTracksToStart[j];
                  if (sttTrack.path == path) {
                    sttTrack.uploadStatus =
                      MusicTrackSelection.UPLOAD_STATUS_UPLOADED;
                    this.setState({
                      tempSelectedTracks: [...tempSelectedTracksToStart],
                    });
                    break;
                  }
                }
              }
            }
          } else {
            const message = {
              title: translate(
                `smartSpeaker.errors.${uploadResponse.body || "NotEnoughSpace"}`
              ),
              variant: "top-accent",
              status: "error",
              duration: 2500,
            };
            this.props.messageToast(message);
          }
        } catch (error) {
          console.log("error on uploading track", error, "at", new Date());
        }
      }

      if (this.FileBrowserRef && this.FileBrowserRef.files) {
        for (let i = 0; i < this.FileBrowserRef.files.length; i++) {
          try {
            const track = this.FileBrowserRef.files[i];

            var payload = new FormData();
            payload.append("playListId", id);
            payload.append("playListUId", uId);
            payload.append("order", tracks.length + 1 + i);
            payload.append("duration", 0);
            payload.append("isPublic", isPublic);
            payload.append("track", track);
            payload.append("buildingId", buildingId);
            payload.append("storageServerId", speaker?.storageServerId);

            var uploadResponse = await axios.post(uploadApi, payload, {
              method: "POST",
              headers: headersMultiPart,
            });
            if (uploadResponse.status == 200) {
              if (uploadResponse && uploadResponse.data) {
                // console.log("uploadResponse", uploadResponse.data);
                this.props.addTrackLocally(uploadResponse.data, id);
              }
            } else {
              const message = {
                title: translate(
                  `smartSpeaker.errors.${
                    uploadResponse.body || "NotEnoughSpace"
                  }`
                ),
                variant: "top-accent",
                status: "error",
                duration: 2500,
              };
              this.props.messageToast(message);
            }
          } catch (error) {
            console.error("error on upload music file", error);
          }
        }
      }

      var orderedTracks = tracks.map((t) => {
        return {
          id: t.id,
          order: t.order,
        };
      });

      var reOrderModel = {
        playListId: id,
        tracks: orderedTracks,
      };
      try {
        await axios.post(`${serverUrl}MultiMedia/ReOrderTracks`, reOrderModel, {
          headers: headersJson,
        });

        this.props.reOrderTracksLocally(id, orderedTracks);
      } catch (error) {
        console.log("error on re order tracks", error);
      }
    }

    this.props.navigation.goBack();
  }

  // create or edit play list entity
  renderForm() {
    const screenTitle = this.state.id
      ? this.state.title || translate("app.noName")
      : translate("multiMedia.newPlayList");
    var serverItems = this.state.tracks.map((t) => {
      var model = new MusicTrackSelection();
      model.id = t.id;
      model.title = t.title;
      model.order = t.order;
      model.isRemoved = t.isRemoved || false;
      model.uploadStatus = MusicTrackSelection.UPLOAD_STATUS_SERVER;
      return model;
    });

    var tempItems = [...this.state.tempSelectedTracks];

    var webFiles = [];
    if (this.FileBrowserRef && this.FileBrowserRef.files) {
      for (var i = 0; i < this.FileBrowserRef.files.length; i++) {
        var model = new MusicTrackSelection();
        // model.id = t.id;
        model.title = this.FileBrowserRef.files[i].name;
        model.order = serverItems.length + 1 + tempItems.length + 1 + i;
        model.isRemoved = false;
        model.uploadStatus = MusicTrackSelection.UPLOAD_STATUS_NONE;
        model.deletable = false;
        webFiles.push(model);
      }
    }

    var musicItems = serverItems
      .concat(tempItems)
      .concat(webFiles)
      .sort((a, b) => a.order - b.order);

    return (
      <View style={styles.container}>
        <View
          style={{
            flexDirection: "row",
            justifyContent: "space-between",
            marginBottom: 20,
          }}
        >
          <Text style={styles.screenTitle}>{screenTitle}</Text>
          {this.state.id > 0 && (
            <IconButton
              style={{
                width: 30,
                height: 30,
                marginEnd: 10,
                borderRadius: 15,
                backgroundColor: Theme.COLORS.ERROR,
                justifyContent: "center",
              }}
              onPress={this.showDeletePlaylistConfirm}
              icon={{
                code: faTrashAlt,
                style: {
                  fontFamily: FONT_FAMILIES.PRO_LIGHT,
                  fontSize: 16,
                  color: Theme.COLORS.WHITE,
                },
              }}
            />
          )}
        </View>
        {/* title */}
        <InputBase
          containerStyle={{
            marginBottom: 20,
            // backgroundColor: Theme.COLORS.LIGHT_MAIN,
          }}
          isInvalid={this.state.validation_title_hasError}
          label={translate("multiMedia.title")}
          onChangeText={(txt) =>
            this.setState({
              title: txt,
              validation_title_hasError: txt.length == 0,
            })
          }
          value={this.state.title}
          icon={faEdit}
        />
        {/* access */}
        <View
          style={{
            flexDirection: "row",
            marginTop: 10,
            // justifyContent: "center",
          }}
        >
          <Text style={{ marginEnd: 15 }}>
            {translate("multiMedia.availableFor")}
          </Text>
          <Switch
            isOn={this.state.isPublic}
            onColor={Theme.COLORS.ACTIVE}
            offColor={Theme.COLORS.MUTED}
            size="small"
            onToggle={(v) => {
              this.setState({
                isPublic: !this.state.isPublic,
              });
            }}
          />
          {this.state.isPublic ? (
            <Text
              onPress={() => {
                this.setState({
                  isPublic: true,
                });
              }}
              style={{
                paddingTop: 3,
                color: this.state.isPublic
                  ? Theme.COLORS.ACTIVE
                  : Theme.COLORS.MUTED,
              }}
            >
              {translate("multiMedia.everyone")}
            </Text>
          ) : (
            <Text
              onPress={() => {
                this.setState({
                  isPublic: false,
                });
              }}
              style={{
                paddingTop: 3,
                color: this.state.isPublic
                  ? Theme.COLORS.MUTED
                  : Theme.COLORS.ACTIVE,
              }}
            >
              {translate("multiMedia.justMe")}
            </Text>
          )}
        </View>
        {/* music tracks */}
        <View style={styles.container}>
          <TouchableHighlight
            underlayColor={Theme.COLORS.ERROR}
            onPress={() => {
              if (Platform.OS == "web") {
                try {
                  // open file browser if exists (web only)
                  this.FileBrowserRef &&
                    typeof this.FileBrowserRef.showPicker == "function" &&
                    this.FileBrowserRef.showPicker();
                } catch (e) {
                  console.error("error on open file upload dialogue");
                  console.error(e);
                }
              } else {
                this.setState({
                  renderMode: RENDER_MODE.LIST,
                });
              }
            }}
            style={{
              backgroundColor: Theme.COLORS.ERROR,
              height: 35,
              justifyContent: "center",
              marginBottom: 10,
            }}
          >
            <Text style={{ textAlign: "center", color: Theme.COLORS.WHITE }}>
              <SimpleIcon
                icon={faPlusCircle}
                color={Theme.COLORS.WHITE}
                size={14}
              />{" "}
              {translate("multiMedia.addSong")}
            </Text>
          </TouchableHighlight>
          {Platform.OS == "web" && (
            <input
              type="file"
              multiple
              accept="audio/*"
              style={{ display: "none" }}
              ref={(ref) => (this.FileBrowserRef = ref)}
              onChange={(event) => {
                try {
                  this.setState({ random: Math.random() });
                  // if (
                  //   files.length > 0 &&
                  //   typeof this.props.onSelect == "function"
                  // ) {
                  //   this.props.onSelect(files);
                  // }
                } catch (e) {
                  console.error("error on read uploaded files");
                  console.error(e);
                }
              }}
            />
          )}
          {/* <ScrollView style={styles.container}> */}
          <DraggableFlatList
            // style={{ flex: 1 }}
            data={musicItems}
            keyExtractor={(item, idx) => idx.toString()}
            onDragEnd={(dragData) => {
              this.manuallyChangeTracksSort(dragData.from, dragData.to);
            }}
            renderItem={({ item, index, drag, isActive }) => {
              return this.renderMusicItem(item, index, isActive, drag);
            }}
          />
          {/* {musicItems.map((t, i) => {
              return this.renderMusicItem(t, i);
            })} */}
          {/* </ScrollView> */}
        </View>
        {/* confirm buttons */}
        <HStack space={2} style={{ marginHorizontal: 10 }}>
          <ArButton
            isLoading={this.state.isSaving}
            color="primary"
            onPress={() => this.save()}
            style={{ flex: 1 }}
          >
            {translate("app.save")}
          </ArButton>
          <ArButton
            color="muted"
            onPress={() => this.goBack()}
            style={{ flex: 1 }}
          >
            {translate("app.goBack")}
          </ArButton>
        </HStack>
        {this.state.deviceId > 0 && (
          <ArButton
            color="success"
            style={{ width: "100%" }}
            onPress={() => this.goToDeviceLog()}
          >
            {translate("area.logs")}
          </ArButton>
        )}
      </View>
    );
  }

  // list of all local music files to select
  renderList() {
    if (!this.state.tracksLoaded) {
      return <Loading message={translate("app.pleaseWaite")} />;
    } else {
      return (
        <View style={styles.container}>
          <View style={{ flexDirection: "row" }}>
            <View style={{ flex: 1, marginStart: 10, marginEnd: 5 }}>
              <InputSearch
                placeholder={translate("app.search")}
                value={this.state.searchFilter}
                onChangeText={(txt) => {
                  this.setState({ searchFilter: txt }); // set filter text and clear checked items.
                }}
              />
            </View>
          </View>
          <View style={{ marginStart: 10, height: 20 }}>
            {this.state.tempSelectedTracks.length > 0 && (
              <Text style={{ fontSize: 11, color: Theme.COLORS.MUTED }}>
                {this.state.tempSelectedTracks.length}{" "}
                {translate("app.itemsSelected")}
              </Text>
            )}
          </View>
          <ScrollView style={styles.container}>
            {this.state.localTracks
              .filter((t) => {
                var _search = "";
                if (this.state.searchFilter)
                  _search = this.state.searchFilter.toLowerCase();
                return (
                  !_search ||
                  (t.title && t.title.toLowerCase().indexOf(_search) >= 0) ||
                  (t.author && t.author.toLowerCase().indexOf(_search) >= 0) ||
                  (t.album && t.album.toLowerCase().indexOf(_search) >= 0)
                );
              })
              .map((track, idx) => {
                var isPlaying = this.state.tempPlayingPath == track.path;
                var isSelected = this.state.tempSelectedTracks.some(
                  (t) => t.path == track.path
                );
                return (
                  <View
                    key={idx}
                    style={[
                      styles.trackItem,
                      isPlaying ? { backgroundColor: "#fce6ed" } : {},
                    ]}
                  >
                    {isPlaying && (
                      <View
                        style={{
                          position: "absolute",
                          width: "100%",
                          flexDirection: "row",
                          justifyContent: "space-around",
                        }}
                      >
                        <Image
                          style={{ width: 280, height: 280 }}
                          width={280}
                          height={280}
                          source={require("../../assets/images/audio-playing-animation.gif")}
                        />
                      </View>
                    )}
                    <TouchableHighlight
                      underlayColor="transparent"
                      onPress={() => {
                        if (isSelected) {
                          this.removeTrackFromTempList(track.path);
                        } else {
                          this.addTrackToTempList(track);
                        }
                      }}
                    >
                      <SimpleIcon
                        icon={isSelected ? faCheckSquare : faSquare}
                        size={26}
                        color={Theme.COLORS.MUTED}
                      />
                    </TouchableHighlight>
                    <TouchableWithoutFeedback
                      onPress={() => {
                        if (isSelected) {
                          this.removeTrackFromTempList(track.path);
                        } else {
                          this.addTrackToTempList(track);
                        }
                      }}
                    >
                      <View>
                        <Text
                          style={{
                            backgroundColor: "#fffe",
                            paddingHorizontal: 5,
                            borderRadius: 5,
                            textAlign: "center",
                          }}
                          numberOfLines={1}
                          ellipsizeMode={"middle"}
                        >
                          {track.title}
                        </Text>
                        <Text
                          style={{
                            backgroundColor: "#fffe",
                            paddingHorizontal: 5,
                            borderRadius: 5,
                            textAlign: "center",
                            fontSize: 10,
                          }}
                        >
                          {track.author || track.album}
                        </Text>
                      </View>
                    </TouchableWithoutFeedback>

                    <TouchableHighlight
                      underlayColor="transparent"
                      onPress={async () => {
                        if (isPlaying && Platform.OS != "web") {
                          await TrackPlayer.stop();
                          this.setState({ tempPlayingPath: "" });
                        } else if (Platform.OS != "web") {
                          console.log("track.path", track.path);
                          await TrackPlayer.reset();
                          await TrackPlayer.add({
                            id: 1,
                            url: track.path,
                            title: track.title,
                            artist: track.author,
                            artwork: track.cover,
                          });
                          await TrackPlayer.play();
                          this.setState({
                            tempPlayingPath: track.path,
                          });
                        }
                      }}
                    >
                      <SimpleIcon
                        icon={isPlaying ? faPauseCircle : faPlayCircle}
                        size={26}
                        color={Theme.COLORS.MUTED}
                      />
                    </TouchableHighlight>
                  </View>
                );
              })}
          </ScrollView>
          <HStack
            space={2}
            style={{
              marginVertical: 10,
              paddingHorizontal: 10,
            }}
          >
            <ArButton
              color="primary"
              onPress={() => {
                this.setState({
                  renderMode: RENDER_MODE.FORM,
                });
                if (Platform.OS != "web") TrackPlayer.reset();
              }}
              style={{ flex: 1 }}
            >
              {translate("app.confirm")}
            </ArButton>
            <ArButton
              color="muted"
              onPress={() => {
                this.setState({
                  tempSelectedTracks: [],
                  renderMode: RENDER_MODE.FORM,
                });
                if (Platform.OS != "web") TrackPlayer.reset();
              }}
              style={{ flex: 1 }}
            >
              {translate("app.cancel")}
            </ArButton>
          </HStack>
        </View>
      );
    }
  }

  renderMusicItem(
    musicTrackSelection = new MusicTrackSelection(),
    idx,
    isActive,
    drag
  ) {
    // console.log("musicTrackSelection in renderMusicItem", musicTrackSelection);
    var canDrag = typeof drag === "function";
    if (isActive == undefined) isActive = false;

    var icon = "";
    var iconColor = Theme.COLORS.MUTED;
    if (!musicTrackSelection.isRemoved) {
      switch (musicTrackSelection.uploadStatus) {
        case MusicTrackSelection.UPLOAD_STATUS_UPLOADED:
          icon = faCheck;
          iconColor = Theme.COLORS.SUCCESS;
          break;
        case MusicTrackSelection.UPLOAD_STATUS_UPLOADING:
          icon = faUpload;
          break;
        case MusicTrackSelection.UPLOAD_STATUS_WAITING:
          icon = faHourglass;
          break;
        case MusicTrackSelection.UPLOAD_STATUS_SERVER:
          icon = faCheckCircle;
          break;
        case MusicTrackSelection.UPLOAD_STATUS_NONE:
        default:
          break;
      }
    }
    return (
      <SimpleDraggableItem
        key={idx}
        number={idx + 1}
        onDragAreaPress={drag}
        onManuallyChange={(from, to) => {
          this.manuallyChangeTracksSort(from, to);
        }}
        isDragging={isActive}
        canDrag={musicTrackSelection.deletable && canDrag}
      >
        <View
          style={{
            flexDirection: "row",
            alignItems: "center",
            height: 52,
            borderBottomWidth: 1,
            borderColor: Theme.COLORS.BORDER,
          }}
          key={idx}
        >
          <SimpleIcon icon={icon} size={26} color={iconColor} />
          <Text
            style={{
              flex: 1,
              paddingHorizontal: 5,
              textDecorationLine: musicTrackSelection.isRemoved
                ? "line-through"
                : "none",
            }}
            numberOfLines={1}
            ellipsizeMode={"tail"}
          >
            {musicTrackSelection.title}
          </Text>
          {musicTrackSelection.deletable && (
            <IconButton
              onPress={() => {
                if (musicTrackSelection.isTemp) {
                  this.removeTrackFromTempList(musicTrackSelection.path);
                } else {
                  // mark as removed to be handle on server
                  this.toggleTrackRemoved(musicTrackSelection.id);
                }
              }}
              style={{}}
              icon={{
                code: musicTrackSelection.isTemp
                  ? faMinusCircle
                  : musicTrackSelection.isRemoved
                  ? faUndo
                  : faTrashAlt,
                style: {
                  color: Theme.COLORS.ERROR,
                  fontFamily: FONT_FAMILIES.PRO_LIGHT,
                  fontSize: 26,
                },
              }}
            />
          )}
        </View>
      </SimpleDraggableItem>
    );
  }

  render() {
    if (this.state.isLoading) {
      return <Loading message={translate("app.pleaseWaite")} />;
    } else {
      return (
        <KeyboardAvoidingView
          behavior="height"
          style={{ flex: 1 }}
          enabled={true}
          //keyboardVerticalOffset={80}
        >
          <ScrollView style={{ flex: 1 }}>
            {this.state.renderMode == RENDER_MODE.FORM && this.renderForm()}
            {this.state.renderMode == RENDER_MODE.LIST && this.renderList()}
          </ScrollView>
          {/** validation alert */}
          {this.state.showingValidationErrors && (
            <AlertDialogBase
              isOpen={true}
              cancelText={translate("app.close")}
              cancelVariant="outline"
              onClose={() => this.dismissValidationAlert()}
            >
              <Text>{" - " + this.state.validationErrors.join("\r\n - ")}</Text>
            </AlertDialogBase>
          )}

          {/* confirm delete playlist */}
          {this.state.showDeleteConfirm > 0 && (
            <AlertDialogBase
              isOpen={true}
              confirmText={translate("app.confirm")}
              colorConfirm="error"
              confirmHandler={() => {
                this.props.deletePlaylist(
                  this.state.id,
                  this.state.uId,
                  this.state.accessToken
                );
                this.hideDeletePlaylistConfirm();
                this.goBack();
              }}
              onClose={() => this.hideUnlockDoorConfirm()}
            >
              <Text>
                {translate("device.confirmDeletePlayList", {
                  title: this.state.title,
                })}
              </Text>
            </AlertDialogBase>
          )}
        </KeyboardAvoidingView>
      );
    }
  }
}

const styles = StyleSheet.create({
  container: { flex: 1, padding: 15, backgroundColor: Theme.COLORS.WHITE },
  trackItem: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    height: 48,
    borderTopWidth: 1,
    borderBottomWidth: 1,
    borderColor: Theme.COLORS.BORDER,
    marginTop: -1,
    overflow: "hidden",
    padding: 3,
    backgroundColor: Theme.COLORS.WHITE,
  },
});

const mapStateToProps = (state) => {
  return {
    DeviceReducer: state.DeviceReducer,
    AppReducer: state.AppReducer,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    updatePlaylistLocally: (playList) =>
      dispatch(Actions.UpdatePlaylistLocally(playList)),
    addPlaylistLocally: (playList) =>
      dispatch(Actions.AddPlaylistLocally(playList)),
    addTrackLocally: (track, playListId) =>
      dispatch(Actions.AddTrackLocally(track, playListId)),
    removeTrackLocally: (trackId, playListId) =>
      dispatch(Actions.RemoveTrackLocally(trackId, playListId)),
    reOrderTracksLocally: (playListId, tracks) =>
      dispatch(Actions.ReOrderTracksLocally(playListId, tracks)),
    deletePlaylist: (id, uId, accessToken) =>
      dispatch(Actions.DeletePlaylist(id, uId, accessToken)),
    messageToast: (message) => {
      dispatch(messageToast(message));
    },
  };
};

class MusicTrackSelection {
  static UPLOAD_STATUS_NONE = 0;
  static UPLOAD_STATUS_UPLOADED = 1;
  static UPLOAD_STATUS_UPLOADING = 2;
  static UPLOAD_STATUS_WAITING = 3;
  static UPLOAD_STATUS_SERVER = 4;
  constructor() {
    this.id = "";
    this.title = "";
    this.path = "";
    this.isTemp = false;
    this.isRemoved = false;
    this.deletable = true;
    this.order = 0;
    this.duration = 0;
    this.uploadStatus = MusicTrackSelection.UPLOAD_STATUS_NONE;
    this.blob = null;
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(MediaPlayListFormScreen);
